/**
 * ParallaxMove applies a parallax effect to an element( @el )  based on the provided @options
 * The options object can contain properties like offset, mobile, dir, headerFixed, twoWay, and parentEl.
 * The function calculates various parameters like speed, scrollPortion, and whether to disable the parallax effect based on the options and the element's position
 * Depending on these parameters, it applies a transform to the element to create the parallax effect
 */
const ParallaxMove = (el, options) => {
    if (typeof window === "undefined") return;

    const settings = Object.assign(
        {
            offset: 0,
            mobile: true,
            dir: "top",
            headerFixed: false,
            twoWay: false,
            parentEl: "section",
        },
        options
    );
    const currEl = el,
        wH = window.innerHeight,
        wW = window.innerWidth,
        hH = document.querySelector("header")?.offsetHeight || 0,
        parent = currEl.closest(settings.parentEl),
        boundingBox = parent.getBoundingClientRect(),
        parentTop = boundingBox.top,
        parentBottom = boundingBox.bottom,
        speed = settings.headerFixed ? settings.offset / (wH - hH) : settings.offset / wH,
        inViewHeight = wH - parentTop,
        checkTwoWay = !settings.twoWay ? parentTop >= 100 : parentTop >= boundingBox.height * -1,
        scrollPortion =
            settings.dir === "top" || settings.dir === "right"
                ? settings.offset - inViewHeight * speed
                : (settings.offset - inViewHeight * speed) * -1,
        disableParallax = wW < 769 && !settings.mobile ? true : false;
    if (parentTop <= parseInt(wH + 100) && parentBottom >= 0 && checkTwoWay && !disableParallax) {
        if (settings.dir === "top") {
            currEl.style.transform = "translate3d(0," + scrollPortion + "px,0)";
            currEl.classList.add("parallax-init");
        } else if (settings.dir === "right") {
            currEl.style.transform = "translate3d(" + scrollPortion + "px, 0, 0)";
            currEl.classList.add("parallax-init");
        }
    } else if (!settings.twoWay && parentTop <= 0) {
        if (!currEl.classList.contains("parallax-init")) {
            currEl.style.transform = "translate3d(0, 0, 0)";
        }
    } else if (disableParallax) {
        currEl.style.removeProperty("transform");
    }
    currEl.classList.add("parallax-item");
};

export default ParallaxMove;
